import Radio from '@material-ui/core/Radio';
import classNames from 'classnames';
import React, { useEffect } from 'react';
import { Button, ButtonMode, ButtonSize } from '../Components/Button';
import { EditIcon, PlusIcon } from '../Components/Icons';
import { MedicationType, OutputType, prettyPrintMedicationType } from '../Contracts/MedicationModels';
import { phoneFormatter } from '../Shared/InputFormatters';
import { useFinalisedMedicationSignalR } from '../SignalR/FinalisedMedicationSignalR';
import { primary } from '../Styles/Colours';
import styles from './FinalisationPrintSelection.module.css';
import { useMedicationSettings } from '../Config/MedicationConfig';
function createMedicationTypeBlurb(medType) {
    switch (medType) {
        case MedicationType.TakeHomeScript:
            return '';
        case MedicationType.MedicationOrder:
            return 'Orders will appear in the supply and administration area. No output will be produced.';
        case MedicationType.MedicationHistory:
            return 'No output will be produced for this medication type.';
        case MedicationType.EnrmcScript:
            return 'Medications will be added to the electronic medication chart. No output will be produced.';
        case MedicationType.ComplementaryTherapyOrder:
            return 'Medications will be added to the electronic medication chart. No output will be produced.';
    }
    return '';
}
var FinaliseSection = function (props) {
    var meds = props.medications.filter(function (it) { return it.type === props.medicationType; });
    if (!(meds.length > 0))
        return null;
    useEffect(function () {
        if (!!props.options && props.options.length == 1) {
            props.toggleOutputSelection(props.medicationType, props.options[0].value);
        }
    }, []);
    var blurb = createMedicationTypeBlurb(props.medicationType);
    return (React.createElement("div", { className: styles.selectionContainer },
        meds.length && (React.createElement("div", { className: styles.selectionHeader },
            React.createElement("span", { className: styles.number }, meds.length),
            React.createElement("div", { className: styles.labelWrapper },
                React.createElement("div", { className: styles.label }, prettyPrintMedicationType(props.medicationType)),
                blurb && React.createElement("div", { className: styles.blurb }, blurb)))),
        !!props.options && props.options.length > 0 && (React.createElement("div", { className: styles.options }, props.options.map(function (it, index) {
            var _a;
            var _b;
            return (React.createElement("div", { key: it.value, className: classNames(styles.option, (_a = {}, _a[styles.disabled] = it.disabled, _a)), "data-test-id": it.testId, onClick: function () {
                    !it.disabled && props.toggleOutputSelection(props.medicationType, it.value);
                } },
                React.createElement("div", { className: styles.radioAndLabelWrapper },
                    React.createElement("div", { className: styles.radio },
                        React.createElement(Radio, { size: 'small', checked: it.value === ((_b = props.outputSelection) === null || _b === void 0 ? void 0 : _b.outputType), disabled: it.disabled, "data-test-id": it.label })),
                    React.createElement("div", { className: styles.labelWrapper },
                        React.createElement("div", { className: styles.label }, it.label),
                        React.createElement("div", { className: styles.info }, it.info))),
                it.value === OutputType.SendScript && !!props.showPatientDialog && (React.createElement("div", { className: styles.buttonWrapper },
                    React.createElement(Button, { mode: ButtonMode.text, size: ButtonSize.small, color: primary, startIcon: it.disabled ? (React.createElement(PlusIcon, { color: primary, size: '24' })) : (React.createElement(EditIcon, { color: primary, size: '24' })), noShadowOnHover: true, subtleShadeOnHover: true, testId: "finalise-" + (it.disabled ? 'add' : 'edit') + "-mobile-phone", onClick: function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                            !!props.showPatientDialog && props.showPatientDialog();
                        } }, it.disabled ? 'Add mobile' : 'Edit')))));
        })))));
};
export var FinalisationPrintSelection = function (props) {
    var _a, _b, _c;
    var takeHomeScript = props.outputSelections.find(function (it) { return it.medicationType === MedicationType.TakeHomeScript; });
    var medicationHistory = props.outputSelections.find(function (it) { return it.medicationType === MedicationType.MedicationHistory; });
    var medicationOrder = props.outputSelections.find(function (it) { return it.medicationType === MedicationType.MedicationOrder; });
    var enrmcScript = props.outputSelections.find(function (it) { return it.medicationType === MedicationType.EnrmcScript; });
    var complementaryTherapyOrder = props.outputSelections.find(function (it) { return it.medicationType === MedicationType.ComplementaryTherapyOrder; });
    var medicationSettings = useMedicationSettings();
    useFinalisedMedicationSignalR({
        patient: props.patient,
        onSignalResponse: props.onPatientUpdated
    });
    var mobilePhone = ((_a = props.patient) === null || _a === void 0 ? void 0 : _a.mobilePhone) ? phoneFormatter(props.patient.mobilePhone) : '';
    var mobilePhonePresent = mobilePhone !== '';
    var sendScriptRequestsToScriptExchange = (_c = (_b = medicationSettings === null || medicationSettings === void 0 ? void 0 : medicationSettings.settings) === null || _b === void 0 ? void 0 : _b.sendScriptRequestsToScriptExchange) !== null && _c !== void 0 ? _c : false;
    var finaliseOptions = [];
    if (sendScriptRequestsToScriptExchange) {
        finaliseOptions.push({
            value: OutputType.SendScript,
            label: 'Send ePrescriptions to patient',
            info: mobilePhonePresent ? (React.createElement("span", null,
                "We\u2019ll send your patient\u2019s prescriptions to ",
                React.createElement("span", { className: styles.bold }, mobilePhone),
                ".")) : (React.createElement("span", null, "No mobile phone number found.")),
            testId: 'send-eprescriptions-to-patient',
            disabled: !mobilePhonePresent
        });
    }
    finaliseOptions.push(
    // Left in intentionally
    // {
    //     value: OutputType.PrintScript,
    //     label: 'Print physical scripts',
    //     info: 'To provide to patient in-person.',
    //     testId: 'print-physical-scripts'
    // },
    {
        value: OutputType.NoOutput,
        label: 'Request medication to be ordered for the patient',
        info: React.createElement("span", null, "Select medications to be delivered to a patient preferred pick up address."),
        testId: 'request-medication-to-be-ordered'
    });
    return (React.createElement("div", { className: styles.container },
        React.createElement(FinaliseSection, { toggleOutputSelection: props.toggleOutputSelection, outputSelection: takeHomeScript, medicationType: MedicationType.TakeHomeScript, medications: props.medications, showPatientDialog: props.showPatientDialog, options: finaliseOptions }),
        React.createElement(FinaliseSection, { outputSelection: medicationHistory, medicationType: MedicationType.MedicationHistory, toggleOutputSelection: props.toggleOutputSelection, medications: props.medications }),
        React.createElement(FinaliseSection, { outputSelection: medicationOrder, medicationType: MedicationType.MedicationOrder, toggleOutputSelection: props.toggleOutputSelection, medications: props.medications }),
        React.createElement(FinaliseSection, { outputSelection: enrmcScript, medicationType: MedicationType.EnrmcScript, toggleOutputSelection: props.toggleOutputSelection, medications: props.medications }),
        React.createElement(FinaliseSection, { outputSelection: complementaryTherapyOrder, medicationType: MedicationType.ComplementaryTherapyOrder, toggleOutputSelection: props.toggleOutputSelection, medications: props.medications })));
};
